import { EFontWeight, ELogoSize } from 'constants/enums';

import { EFacebookButtonVariant, LoginThemeFormValues } from './types';

export const defaultLoginTheme: LoginThemeFormValues = {
  text: 'Welcome to a new members-only clubs',
  font: 'montserrat',
  textColor: 'white',
  textSize: 28,
  textWeight: EFontWeight.Bold,
  loginLogoImage: '',
  loginBackgroundImageMobile: '',
  loginBackgroundImageDesktop: '',
  loginLogoSize: ELogoSize.SMALL,
  otpButton: {
    backgroundColor: {
      colorOne: '#7122ff',
      colorTwo: ''
    },
    text: 'OTP Text',
    icon: '',
    textColor: {
      colorOne: '#7122ff',
      colorTwo: ''
    }
  },
  playerIdButton: {
    backgroundColor: {
      colorOne: '#7122ff',
      colorTwo: ''
    },
    text: 'Login with Player ID',
    icon: '',
    textColor: {
      colorOne: '#ffffff',
      colorTwo: ''
    }
  },
  logoutScreen: {
    text: 'Are you sure you want to disconnect?',
    font: '',
    textColor: '#ffffff',
    textSize: 24,
    textWeight: '500'
  },
  facebookButton: {
    variant: EFacebookButtonVariant.DEFAULT
  },
  consentSection: {
    htmlText:
      '<p>By logging in you acknowledge that you have read and agree to the Privacy Policy And Terms and Conditions</p>',
    consentRequired: false
  },
  accountApprovalModal: {
    backgroundImage: 'https://media.appcharge.com/defaults/background.png',
    backgroundColor: {
      colorOne: '#7122ff',
      colorTwo: ''
    },
    borderColor: '#FFFFFF',
    borderWidth: 0,
    buttonTextColor: '#FFFFFF',
    buttonBackgroundColor: {
      colorOne: '#7122ff',
      colorTwo: ''
    },
    textColor: '#FFFFFF',
    additionalText: ''
  },
  errorMessage: {
    title: 'Whoops!',
    subTitle: 'Login failed'
  }
};

const fallback = <T>(value: T | undefined | null | '', defaultValue: T): T =>
  value === undefined || value === null || value === '' ? defaultValue : value;

export const withLoginThemeDefaults = (
  values: LoginThemeFormValues
): LoginThemeFormValues => ({
  ...values,
  textSize: Number(values.textSize),
  playerIdButton: {
    ...values.playerIdButton,
    text: fallback(
      values.playerIdButton?.text,
      defaultLoginTheme.playerIdButton.text
    ),
    icon: fallback(
      values.playerIdButton?.icon,
      defaultLoginTheme.playerIdButton.icon
    ),
    backgroundColor: {
      ...values.playerIdButton?.backgroundColor,
      colorOne: fallback(
        values.playerIdButton?.backgroundColor?.colorOne,
        defaultLoginTheme.playerIdButton.backgroundColor.colorOne
      )
    },
    textColor: {
      ...values.playerIdButton?.textColor,
      colorOne: fallback(
        values.playerIdButton?.textColor?.colorOne,
        defaultLoginTheme.playerIdButton.textColor.colorOne
      )
    }
  },
  logoutScreen: {
    ...values.logoutScreen,
    textSize: Number(values.logoutScreen?.textSize),
    text: fallback(
      values.logoutScreen?.text,
      defaultLoginTheme.logoutScreen.text
    )
  }
});
